import type { ModelMoneyExpense } from '@app/api/MoneyExpenses';
import type { WithActiveBranchId } from '@app/api/shared';

export enum PaymentAccountsEndpoints {
  UpdatePaymentAccount = 'UpdatePaymentAccount',
  GetPaymentAccounts = 'GetPaymentAccounts',
  GetPaymentAccountsForSystem = 'GetPaymentAccountsForSystem',
  UpdatePaymentAccountBalance = 'UpdatePaymentAccountBalance',
  MakeMoneyCollection = 'MakeMoneyCollection',
  GetPaymentAccountById = 'GetPaymentAccountById',
}

export type PayType = 'bank' | 'cash' | 'acquiring' | 'loyalty' | null;

export interface ModelPaymentAccount {
  Id: number;
  BranchId: number | null;
  LegalEntityId: number;
  LegalEntity: string | null;
  Name: string | null;
  Description: string | null;
  PayType: PayType;
  IsDeleted: boolean;
  Bank: string | null;
  BankBik: string | null;
  AccountChecking: string | null;
  AccountCorrespondent: string | null;
  Balance: number;
  IsDefault: boolean;
  MigrateId: number | null;
  UseEmail: boolean | null;
}

export interface ModelBalance {
  ObjectId: number;
  Balance: number;
}

export type UpdatePaymentAccountData = Omit<
  ModelPaymentAccount,
  'IsDefault' | 'LegalEntity' | 'MigrateId' | 'UseEmail'
> & { IsDefault?: ModelPaymentAccount['IsDefault'] };

export interface UpdatePaymentAccountRequest extends WithActiveBranchId {
  data: UpdatePaymentAccountData;
}

export interface GetPaymentAccountsRequest extends WithActiveBranchId {
  branchId: number | null;
  includeDeleted: boolean;
}

export interface GetPaymentAccountsForSystemRequest extends WithActiveBranchId {
  branchId: number | null;
  includeDeleted: boolean;
}

export interface UpdatePaymentAccountBalanceRequest extends WithActiveBranchId {
  paymentAccountId: number;
}

export interface MakeMoneyCollectionRequest extends WithActiveBranchId {
  paymentAccountId: number;
  amount: number;
  comment: string;
}

export interface GetPaymentAccountByIdRequest extends WithActiveBranchId {
  paymentAccountId: number;
}

export type UpdatePaymentAccountResponse = ModelPaymentAccount;
export type GetPaymentAccountsResponse = ModelPaymentAccount[];
export type GetPaymentAccountsForSystemResponse = ModelPaymentAccount[];
export type UpdatePaymentAccountBalanceResponse = ModelBalance;
export type MakeMoneyCollectionResponse = ModelMoneyExpense;
export type GetPaymentAccountByIdResponse = ModelPaymentAccount;
